<template>
  <div class="keiyaku-koushin-type edit-item" v-if="editingData">

    <div class="head"><b>更新の有無</b></div>
    <div class="data flex">
      <div>
        <select-box class="medium" :options="koushinOptions" v-model="editingData.is_keiyaku_koushin"
          :selectedIndex="selectedIndex" :disabled="disabled"></select-box>
        <p class="current-data">{{ currentData?.is_keiyaku_koushin === null ? Message.UPDATE_UNSELECTED : currentData?.is_keiyaku_koushin === 1 ? "有" : '無' }}</p>
      </div>
      <div class="notice">
        <p class="pre" v-if="editingData.is_keiyaku_koushin === 1">{{ Message.UPDATE_TRUE }}</p>
        <p class="pre" v-else-if="editingData.is_keiyaku_koushin === 0">{{ Message.UPDATE_NONE }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';
import Message from "@/const/KoyouKeiyaku/Message";
import { BaseOptionWithoutCode } from '@/types/Option';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup(props) {
    const koushinOptions: BaseOptionWithoutCode[] = [
      {val: null, label: "無選択"},
      {val: 0, label: "無"},
      {val: 1, label: "有"}
    ]

    const selectedIndex = koushinOptions.findIndex(v => {
      return v.val === props.editingData?.is_keiyaku_koushin
    })

    return {
      Message,
      koushinOptions,
      selectedIndex
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

.notice {
  margin-left: 20px;
}
</style>
